import React, { useState, useEffect } from "react";
import styles from "./TemplateHero24.module.css";

const TemplateHero24 = ({ branding, heroData }) => {
  const [current, setCurrent] = useState(0);
  const slides = heroData?.slides || [];

  useEffect(() => {
    if (slides.length <= 1) return;

    const t = setInterval(() => {
      setCurrent((p) => (p + 1) % slides.length);
    }, 5000);

    return () => clearInterval(t);
  }, [slides.length]);

  if (!slides.length) return null;

  const visible = slides.length >= 4 ? slides.slice(0, 4) : slides;

  return (
    <div className={styles.root}>
      
      {/* LEFT PANEL */}
      <div className={styles.left}>
        <div className={styles.kicker}>
          <span className={styles.kickerDot} />
          {branding?.companyName || "Travel Experts"}
        </div>

        <h1 className={styles.title}>{slides[current].title}</h1>

        <p className={styles.sub}>{slides[current].subtitle}</p>

        <div className={styles.stats}>
          <div>
            <span className={styles.statVal}>500+</span>
            <span className={styles.statLbl}>Packages</span>
          </div>

          <div>
            <span className={styles.statVal}>98%</span>
            <span className={styles.statLbl}>Satisfaction</span>
          </div>

          <div>
            <span className={styles.statVal}>50+</span>
            <span className={styles.statLbl}>Countries</span>
          </div>
        </div>

        <div className={styles.btns}>
          <button className={styles.btnPrimary}>View Packages</button>
          <button className={styles.btnGhost}>Learn More</button>
        </div>

        <div className={styles.dots}>
          {slides.map((_, i) => (
            <div
              key={i}
              className={`${styles.dot} ${
                i === current ? styles.activeDot : ""
              }`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>

      {/* RIGHT MOSAIC */}
      <div className={styles.mosaic}>
        {visible.map((s, i) => (
          <div
            key={i}
            className={styles.cell}
            style={{ backgroundImage: `url('${s.image}')` }}
            onClick={() => setCurrent(i)}
          >
            <div className={styles.cellOverlay} />

            <span className={styles.cellNum}>
              0{i + 1}
            </span>

            {i === current && (
              <span className={styles.activeBadge}>
                Featured
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateHero24;